import { useContext, useEffect, useMemo, useState } from "react";

import { privacyLink, termsLink } from "../../../../globalConstants";
import axios from "../../../components/api/axios";
import Modal from "../../../components/global/Modal";
import ResponseModal from "../../../components/global/ResponseModal";
import { userDBService } from "../../../components/ui library/helpers/dbInstances";
import DataContext from "../../../context/DataContext";

const ConditionsModal = () => {
  const privacyKey = process.env.REACT_APP_PRIVACY_KEY;
  const termsKey = process.env.REACT_APP_TERMS_KEY;
  const { loggedInUser } = useContext(DataContext);
  const [openModal, setOpenModal] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const hasAcceptedPrivacy = useMemo(
    () => loggedInUser?.attributes && !!loggedInUser.attributes[privacyKey],
    [loggedInUser]
  );
  const hasAcceptedTerms = useMemo(
    () => loggedInUser?.attributes && !!loggedInUser.attributes[termsKey],
    [loggedInUser]
  );

  const handleSubmit = async () => {
    try {
      const body = {
        ...(!hasAcceptedPrivacy && { [privacyKey]: new Date() }),
        ...(!hasAcceptedTerms && { [termsKey]: new Date() }),
      };
      const headers = {
        "Content-Type": "application/json",
      };
      const resp = await axios.post(`api/users/${loggedInUser.pk}/attributes/`, body, {
        headers,
      });
      await userDBService.save("userDetail", {
        ...loggedInUser,
        attributes: resp.data,
      });
      setOpenModal(false);
    } catch (error) {
      setOpenError(true);
      setErrorArray(error);
    }
  };

  useEffect(() => {
    if (!hasAcceptedPrivacy || !hasAcceptedTerms) {
      setOpenModal(true);
      if (!hasAcceptedPrivacy) {
        setIsPrivacy(true);
        return;
      }
      if (!hasAcceptedTerms) {
        setIsPrivacy(false);
      }
    }
  }, [hasAcceptedPrivacy, hasAcceptedTerms]);

  return (
    <>
      <Modal
        open={openModal}
        maxWidth="sm"
        closable={false}
        actions={[
          {
            onClick: isPrivacy ? () => setIsPrivacy(false) : () => handleSubmit(),
            label: "Acknowledge",
            className:
              "bg-blue-600 text-white hover:bg-blue-700 disabled:text-white disabled:bg-blue-400",
          },
        ]}
      >
        <iframe
          src={isPrivacy ? privacyLink : termsLink}
          width="100%"
          height="500px"
          title="PDF Viewer"
        />
      </Modal>
      <ResponseModal
        title="Something went wrong"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  );
};

export default ConditionsModal;
